import { Button, FileButton } from "@mantine/core";
import { IconUpload } from "@tabler/icons-react";
import { useCallback, useState } from "react";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import Card from "src/components/shared/Card/Card";
import Loader from "src/components/shared/Loader/Loader";
import { useGetApi, usePostApi, useUploadFileApi } from "src/hooks";
import { ButtonsWrapper, CardsContainer, PageContainer } from "src/styled";
import { openBase64 } from "src/utils";
import { Notification } from "src/utils/Notification";

import { useSelector } from "../../../redux/hooks";
import { type ICertificate } from "./Certificates.types";
import { set } from "react-hook-form";
import dayjs from "dayjs";
const mapCertificates = (data: any) => data.data.content.list as ICertificate[];
const Certificates = () => {
  const { yachtAdmin } = useSelector(state => state.permsSlice);
  const { post } = usePostApi();
  const [isLoadingCerts, setIsLoadingCerts] = useState(false);
  const { data, refetch, isLoading } = useGetApi({
    request: "get-settings",
    body: { params: { sect: "_certs" } },
    mapper: mapCertificates,
  });
  const { upload, isUploading } = useUploadFileApi();

  const handleUpload = async (file: File) => {
    if (isUploading) return;
    await upload("upload-cert", [file], {}, async () => {
      Notification(
        "Success",
        "The certificate has been added successfully",
        "green",
      );
      setIsLoadingCerts(true);
      await refetch();
      setIsLoadingCerts(false);
    });
  };

  const handleFileOpen = ({ data, type, filename }: ICertificate) => {
    openBase64(data, type, filename);
  };
  const handleDelete = async (cid: string) => {
    await post({
      request: "delete-cert",
      body: { params: { cid } },
      onSuccess: async () => {
        Notification("Success", "The certificate has been deleted", "green");
        setIsLoadingCerts(true);
        await refetch();
        setIsLoadingCerts(false);
      },
    });
  };

  const renderPDFCards = useCallback(() => {
    if (!data) return;
    return data.map(item => (
      <Card
        key={item.cid}
        cardName={item.filename}
        cardDetails={dayjs(item.date).format("DD-MMM-YYYY - HH:mm")}
        data={item.data}
        button={item.type}
        onClick={() => handleFileOpen(item)}
        onDelete={
          item.protected === 0
            ? yachtAdmin
              ? () => {
                  void handleDelete(item.cid);
                }
              : undefined
            : undefined
        }
      />
    ));
  }, [data, yachtAdmin]);

  return (
    <PageContainer>
      <Breadcrumbs>
        <ButtonsWrapper>
          <FileButton
            onChange={handleUpload}
            accept="image/png,image/jpeg,application/pdf">
            {props => (
              <Button
                leftIcon={<IconUpload size={"1.4rem"} />}
                variant="outline"
                loading={isUploading}
                {...props}>
                Add Document
              </Button>
            )}
          </FileButton>
        </ButtonsWrapper>
      </Breadcrumbs>
      <CardsContainer>
        {(isLoading && !data) || isLoadingCerts ? <Loader /> : renderPDFCards()}
      </CardsContainer>
    </PageContainer>
  );
};

export default Certificates;
